import React from "react"
import ContentLoader from "react-content-loader"

export default function LoadingPlaceholder() {
  return (
    <ContentLoader viewBox="0 0 380 400">
      <circle cx="190" cy="50" r="44"/>
      <rect x="140" y="105" rx="5" ry="10" width="100" height="20"/>
      <rect x="140" y="130" rx="5" ry="10" width="100" height="10"/>
    </ContentLoader>
  )
}
